import { render, staticRenderFns } from "./updates-card.vue?vue&type=template&id=4a9aa9ae"
import script from "./updates-card.vue?vue&type=script&lang=js"
export * from "./updates-card.vue?vue&type=script&lang=js"
import style0 from "./updates-card.vue?vue&type=style&index=0&id=4a9aa9ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports